import React from 'react';
import Button from '../../../components/ui/Button';

/**
 * Table⇄Chart segmented control. Table is the default and the source of truth;
 * the toggle swaps the render only, never the data.
 */
const SectionToggle = ({ value, onChange }) => (
  <div className="inline-flex gap-0.5">
    <Button size="xs" variant={value === 'table' ? 'default' : 'ghost'} onClick={() => onChange('table')}>
      Table
    </Button>
    <Button size="xs" variant={value === 'chart' ? 'default' : 'ghost'} onClick={() => onChange('chart')}>
      Chart
    </Button>
  </div>
);

export default SectionToggle;
